import React, { useLayoutEffect, useEffect } from 'react'
import { useParams, useSearchParams, useNavigate } from 'react-router-dom'
import { setPage } from 'features/ui/uiSlice'
import { Page } from 'features/ui/types'
import { useAppDispatch } from 'app/hooks'
import { injectStore as injectStoreToLiveReportService } from 'liveReportService/interceptors'
import { useLiveReportUniversalError } from 'hooks/useLiveReportState'
import store from 'app/store'
import { setReportId, setBuildName } from 'features/liveReport/liveReportSlice'
import { ErrorCodes } from 'liveReportService'
import { Title } from 'enums'
import Report from './Report'
import CsrfTokenHandler from './CsrfTokenHandler'
import Login from './Login'
import { ErrorCodeToTranslationKey } from './utils'
import { useLiveReportAuth } from './hooks'
import PreflightLoginCheck from './PreflightLoginCheck'

injectStoreToLiveReportService(store)

const SystemMessageErrorCodes = [
  ErrorCodes.InvalidReportId,
  ErrorCodes.UserNotActive,
  ErrorCodes.OwnerNotActive,
  ErrorCodes.InvalidIpAddress,
  ErrorCodes.ConcurrentSessionLimit,
  ErrorCodes.ReportNotFound
]

const LiveReport = () => {
  const dispatch = useAppDispatch()
  const { reportId } = useParams()
  const [searchParams] = useSearchParams()
  const { isValidSession } = useLiveReportAuth()

  useLayoutEffect(() => {
    dispatch(setPage(Page.LiveReport))
    return () => {
      dispatch(setPage(undefined))
    }
  }, [dispatch])

  useLayoutEffect(() => {
    dispatch(setReportId(reportId))
    dispatch(setBuildName(searchParams.get('build-name') || ''))
  }, [dispatch, reportId, searchParams])

  // handle universal error
  const navigate = useNavigate()
  const error = useLiveReportUniversalError()
  useEffect(() => {
    if (error && SystemMessageErrorCodes.includes(error.status)) {
      navigate('/system-message-live-report', {
        state: { errorCode: ErrorCodeToTranslationKey[error.status] }
      })
    }
  }, [error, navigate])

  // Consider using third party library like react helmet if more title changes are needed.
  useEffect(() => {
    document.title = Title.QUID_MONITOR_LIVE_REPORT
    return () => {
      document.title = Title.QUID_MONITOR
    }
  }, [])

  if (isValidSession === false) {
    return <Login />
  }

  return (
    <PreflightLoginCheck>
      <CsrfTokenHandler>
        <Report id={reportId!} />
      </CsrfTokenHandler>
    </PreflightLoginCheck>
  )
}

export default LiveReport
